import * as React from "react";
import { useState } from "react";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import SortIcon from "../Assests/Category/Sorting.svg";
import EditIcon from "../Assests/Category/editIcon.svg";
import DeleteIcon from "../Assests/Category/deleteIcon.svg";
import ViewItemsModal from "../Components/Category/ViewItemsModal";
import RadioSelect from "../Components/Category/RadioSelect";
import { Link } from "react-router-dom";
import EditDeliveryAddress from "../Components/Attributes/EditAttribute";
import axios from "axios";
import { BASE_URL, SORT_CATOGRY_DATA } from "../Constants/Config";
import { useDispatch } from "react-redux";
import { fetchCategoriesData } from "../Redux/features/Categories/categoriesSlice";
import { fetchAttributesData } from "../Redux/features/Attributes/attributesSlice";
import { useAuthDetails } from "../Common/cookiesHelper";
import EditTaxesModal from "../Components/StoreSetting/Taxes/EditTaxesModal";
import EditEmployeeModal from "../Components/StoreSetting/AddEmployee/EditEmployeeModal";
import Permission from "../Assests/Employee/Permission.svg";
import AlertModal from "./AlertModal";
import SortModal from "./SortModal";
import { useNavigate } from "react-router-dom";
import { SkeletonTable } from "./SkeletonTable";
import NoDataFound from "./NoDataFound";
import AssignStoreDetails from "../Components/StoreSetting/AddEmployee/AssignStoreDetails";
import { PERMISSIONS } from "../Constants/permission";
import { useSelector } from "react-redux";
import AccessDeniedTooltip from "./AccessDeniedTooltip";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "var(--qv-bg-253338, #253338)",
    color: theme.palette.common.white,
    fontFamily: "CircularSTDMedium !important",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    fontFamily: "CircularSTDBook !important",
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
  },
  "& td, & th": {
    border: "none",
  },
}));

const DraggableTable = ({
  tableHead,
  tableRow,
  setFunction,
  viewSelectedOption = false,
  viewSelectedOptionFun,
  editBtnCategory = false,
  deleteButton = false,
  editAttributeObj = false,
  editTaxesObj = false,
  deleteTaxButton = false,
  table,
  employeeTable = false,
  editBtnEmployee = false,
  states,
  setVisible,
  setEmployeeId,
  setProductId,
  seVisible,
  loading,
  handleReturnStoreNamesUsingMerchantId = false,
  disableCategories = false,
  onlineStautusLoaging = false,
  registerStautusLoaging = false,
  categoryId = null,
  categoryOptions = [],
  loadingCategories = false,
  feedbackModalClassName = "",
}) => {
  const dispatch = useDispatch();
  const { LoginGetDashBoardRecordJson, LoginAllStore, userTypeData } =
    useAuthDetails();
  const { permissions, status, error } = useSelector(
    (state) => state.permissions
  );
  const { viewSelectedOptionEnable, fun1, fun2 } = viewSelectedOption;
  const {
    deleteButtonEnable = false,
    deleteButtonFun,
    hasDeletePermission = true,
    showDeleteWhenNoPermission = true,
  } = deleteButton || {};
  const { deleteTaxButtonEnable, deletetaxButtonFun } = deleteTaxButton;
  const {
    editButtonEnable = false,
    editButtonurl,
    hasEditPermission = true,
    showEditWhenNoPermission = true,
  } = editBtnCategory || {};
  const { editButtonEnableEmployee, editButtonurlEmployee } = editBtnEmployee;
  const hideOptionFor = ["manager"];
  const [sortModeConfirmedLoading, setSortModeConfirmedLoading] =
    useState(false);
  const reorder = (list, startIndex, endIndex) => {
    const result = Array?.from(list);
    const [removed] = result?.splice(startIndex, 1);
    result?.splice(endIndex, 0, removed);

    return result;
  };

  const [alertModalOpen, setAlertModalOpen] = useState(false);
  const [alertModalHeaderText, setAlertModalHeaderText] = useState("");
  const showModal = (headerText) => {
    setAlertModalHeaderText(headerText);
    setAlertModalOpen(true);
  };

  const [dragresult, setDragresult] = useState("");
  const [backupedCategoryList, setBackupedCategoryList] = useState([]);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [alternateNameList, setAlternateNameList] = useState({});
  const onDragEnd = async (result) => {
    // Check if the drag ended outside of the droppable area
    if (!result?.destination) {
      // alert("You can't drop outside the list!");
      showModal("You can't drop outside the list!");
      return;
    }

    // Check if the item was dropped at the same position
    if (result?.destination?.index === result?.source?.index) {
      // alert("You haven't moved the item!");
      showModal("You haven't moved the item!");
      return;
    }

    // const reorderedItems = reorder(
    //   tableRow,
    //   result.source.index,
    //   result.destination.index
    // );
    setDragresult(result);
    const sourceIndex = result?.source.index;
    const targetIndex = result?.destination.index;

    const reorderedItems = reorder(tableRow, sourceIndex, targetIndex);

    const draggedAlternateName = reorderedItems[sourceIndex].alternateName;
    const destinationAlternateName = reorderedItems[targetIndex].alternateName;
    let merchant_id = LoginGetDashBoardRecordJson?.data?.merchant_id;

    // Create a new array with updated alternateName values
    const updatedItems = reorderedItems.map((item, index) => {
      /* if (index === sourceIndex) {
        return { ...item, alternateName: destinationAlternateName };
      }
      if (index === targetIndex) {
        return { ...item, alternateName: draggedAlternateName };
      } */

      return item;
    });

    // updatedItems.forEach((category, index) => {
    //   alternameList[`values[${category?.id}]`] = tableRow[index]?.alternateName;
    // });
    const updatedAlternateNameList = {};
    updatedItems.forEach((category, index) => {
      const newAlternateName = generateValue(index);
      updatedAlternateNameList[`values[${category?.id}]`] =
        // tableRow[index]?.alternateName;
        newAlternateName;
    });
    setAlternateNameList(updatedAlternateNameList);
    setBackupedCategoryList(tableRow);
    setFunction(updatedItems);
    setDeleteModalOpen(true);

    // let data = {
    //   table: table,
    //   merchant_id: merchant_id,
    //   token_id: userTypeData?.token_id,
    //   login_type: userTypeData?.login_type,
    // };
    // const userConfirmed = window.confirm(
    //   "Are you sure you want to sort items?"
    // );
    // if (userConfirmed) {
    //   setFunction(updatedItems);
    //   try {
    //     const response = await axios.post(
    //       BASE_URL + SORT_CATOGRY_DATA,
    //       { ...data, ...alternameList },
    //       {
    //         headers: {
    //           "Content-Type": "multipart/form-data",
    //           Authorization: `Bearer ${userTypeData?.token}`,
    //         },
    //       }
    //     );
    //     let data_merchant_id = {
    //       merchant_id: merchant_id,
    //       ...userTypeData,
    //     };
    //     if (table === "collection") {
    //       if (data_merchant_id) {
    //         dispatch(fetchCategoriesData(data_merchant_id));
    //       }
    //     }
    //     if (table === "varients") {
    //       if (data_merchant_id) {
    //         dispatch(fetchAttributesData(data_merchant_id));
    //       }
    //     }
    //     console.log("API response:", response.data);
    //   } catch (error) {
    //     console.error("API call failed:", error);
    //   }
    // } else {
    //   console.log("Sorting canceled by  user");
    // }
  };
  const handleEditEmployeePermission = (id) => {
    setVisible("EmployeePermission");
    setEmployeeId(id);
  };
  const navigate = useNavigate();
  const handleEditCategory = (id) => {
    seVisible("EditCategory");
    setProductId(id);
  };

  function generateValue(index) {
    const alphabet = "abcdefghijklmnopqrstuvwxyz";
    let value = "";
    index += 26; // Start from 'aa'
    while (index >= 0) {
      value = alphabet[index % 26] + value;
      index = Math?.floor(index / 26) - 1;
    }
    return value;
  }

  const confirmDeleteCategory = async () => {
    // const sourceIndex = dragresult?.source?.index;
    // const targetIndex = dragresult?.destination.index;
    // const reorderedItems = reorder(tableRow, sourceIndex, targetIndex);
    let merchant_id = LoginGetDashBoardRecordJson?.data?.merchant_id;

    let data = {
      table: table,
      merchant_id: merchant_id,
      token_id: userTypeData?.token_id,
      login_type: userTypeData?.login_type,
      session_id: userTypeData?.session_id || "",
      login_employee_id: LoginGetDashBoardRecordJson?.employee_id
        ? LoginGetDashBoardRecordJson?.employee_id
        : null,
    };
    // const updatedItems = reorderedItems?.map((item, index) => {
    //   return item;
    // });
    // const alternameList = {};
    // updatedItems.forEach((category, index) => {
    //   let value = generateValue(index);
    //   alternameList[`values[${category?.id}]`] = value;
    // });
    // console.log("altername",alternameList)
    // return
    // console.log("confirmDeleteCategory alternameList",alternameList)
    if (dragresult) {
      // setFunction(updatedItems);
      try {
        if (table === "varients") {
          setSortModeConfirmedLoading(true);
        }

        const response = await axios.post(
          BASE_URL + SORT_CATOGRY_DATA,
          { ...data, ...alternateNameList },
          {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: `Bearer ${userTypeData?.token}`,
            },
          }
        );
        let data_merchant_id = {
          merchant_id: merchant_id,
          ...userTypeData,
        };
        if (table === "collection") {
          // if (data_merchant_id) {
          //   dispatch(fetchCategoriesData(data_merchant_id));
          // }
        }
        if (table === "varients") {
          if (data_merchant_id) {
            dispatch(fetchAttributesData(data_merchant_id));
          }
        }
      } catch (error) {
        console.error("API call failed:", error);
      } finally {
        setSortModeConfirmedLoading(false);
      }
    }
    setDragresult(null);
    setDeleteModalOpen(false);
  };
  return (
    <>
      {loading ? (
        <SkeletonTable columns={tableHead} />
      ) : (
        <>
          <TableContainer
            sx={{ borderTopLeftRadius: "0", borderTopRightRadius: "0" }}
            component={Paper}
          >
            <Table sx={{ minWidth: 500 }}>
              <TableHead>
                <TableRow>
                  {tableHead &&
                    tableHead?.map((item, index) => (
                      <StyledTableCell key={item}>{item}</StyledTableCell>
                    ))}
                </TableRow>
              </TableHead>

              <DragDropContext onDragEnd={onDragEnd}>
                <Droppable droppableId="droppable">
                  {(provided) => (
                    <TableBody
                      ref={provided?.innerRef}
                      {...provided.droppableProps}
                    >
                      {tableRow &&
                        tableRow?.length >= 1 &&
                        tableRow?.map((item, index) => {
                          return hideOptionFor?.includes(
                            userTypeData?.login_type
                          ) &&
                            +item?.is_admin === 1 &&
                            employeeTable ? null : (
                            <Draggable
                              key={item?.id}
                              draggableId={item?.id}
                              index={index}
                            >
                              {(provided) => (
                                <StyledTableRow
                                  ref={provided?.innerRef}
                                  {...provided.draggableProps}
                                  {...provided.dragHandleProps}
                                >
                                  <StyledTableCell sx={{ width: "50px" }}>
                                    <img src={SortIcon} alt="add-icon" />
                                  </StyledTableCell>
                                  {employeeTable ? (
                                    <StyledTableCell sx={{ width: "200px" }}>
                                      {item?.f_name} {item?.l_name}
                                    </StyledTableCell>
                                  ) : (
                                    ""
                                  )}
                                  {employeeTable ? (
                                    <StyledTableCell sx={{ width: "200px" }}>
                                      {item?.phone}
                                    </StyledTableCell>
                                  ) : (
                                    ""
                                  )}
                                  {employeeTable ? (
                                    <StyledTableCell sx={{ width: "300px" }}>
                                      {item?.email}
                                    </StyledTableCell>
                                  ) : (
                                    ""
                                  )}
                                  {employeeTable ? (
                                    <StyledTableCell sx={{ width: "150px" }}>
                                      <AssignStoreDetails
                                        handleReturnStoreNamesUsingMerchantId={
                                          handleReturnStoreNamesUsingMerchantId
                                        }
                                        storeList={item}
                                      />
                                    </StyledTableCell>
                                  ) : (
                                    ""
                                  )}
                                  {employeeTable ? (
                                    <StyledTableCell sx={{ width: "100px" }}>
                                      {+item?.is_admin === 1 ? null : item?.pin}
                                    </StyledTableCell>
                                  ) : (
                                    ""
                                  )}
                                  {employeeTable ? (
                                    <StyledTableCell sx={{ width: "200px" }}>
                                      {item?.role}
                                    </StyledTableCell>
                                  ) : (
                                    ""
                                  )}

                                  {employeeTable ? (
                                    ""
                                  ) : (
                                    <StyledTableCell sx={{ width: "350px" }}>
                                      <div className="">{item?.title}</div>
                                    </StyledTableCell>
                                  )}
                                  {item?.percent ? (
                                    <StyledTableCell sx={{ width: "850px" }}>
                                      {item?.type === "1" ? "$" : ""}
                                      {item?.percent}
                                      {item?.type === "0" ? "%" : ""}
                                    </StyledTableCell>
                                  ) : (
                                    ""
                                  )}
                                  {viewSelectedOption && (
                                    <StyledTableCell sx={{ width: "250px" }}>
                                      <ViewItemsModal
                                        selectedView={item}
                                        onViewClick={viewSelectedOptionFun}
                                      />
                                    </StyledTableCell>
                                  )}
                                  {viewSelectedOptionEnable && (
                                    <StyledTableCell sx={{ width: "550px" }}>
                                      {
                                        <AccessDeniedTooltip hasPermission={disableCategories}>
                                          <RadioSelect
                                            item={item}
                                            handleOnlineChange={
                                              !permissions?.length ||
                                                permissions?.indexOf(
                                                  PERMISSIONS?.MENU_DISABLE_CATEGORIES
                                                ) > -1
                                                ? fun1
                                                : () => { }
                                            }
                                            handleRegisterChange={
                                              !permissions?.length ||
                                                permissions?.indexOf(
                                                  PERMISSIONS?.MENU_DISABLE_CATEGORIES
                                                ) > -1
                                                ? fun2
                                                : () => { }
                                            }
                                            disableCategories={disableCategories}
                                            onlineStautusLoaging={
                                              onlineStautusLoaging
                                            }
                                            registerStautusLoaging={
                                              registerStautusLoaging
                                            }
                                            categoryId={categoryId}
                                          />
                                        </AccessDeniedTooltip>
                                      }
                                    </StyledTableCell>
                                  )}
                                  {editButtonEnable &&
                                    (showEditWhenNoPermission ||
                                      hasEditPermission) && (
                                      <StyledTableCell sx={{ width: "100px" }}>
                                        {showEditWhenNoPermission ? (
                                          <AccessDeniedTooltip
                                            hasPermission={hasEditPermission}
                                          >
                                            <div className="permissionEditBTN">
                                              <span
                                                onClick={() => {
                                                  if (!hasEditPermission) return;
                                                  navigate(
                                                    `${editButtonurl}${item?.id}`
                                                  );
                                                  handleEditCategory(item?.id);
                                                }}
                                                className="cursor-pointer"
                                              >
                                                <img
                                                  selectedCategory={item}
                                                  src={EditIcon}
                                                  alt="Edit"
                                                />
                                              </span>
                                            </div>
                                          </AccessDeniedTooltip>
                                        ) : (
                                          <div className="permissionEditBTN">
                                            <span
                                              onClick={() => {
                                                navigate(
                                                  `${editButtonurl}${item?.id}`
                                                );
                                                handleEditCategory(item?.id);
                                              }}
                                              className="cursor-pointer"
                                            >
                                              <img
                                                selectedCategory={item}
                                                src={EditIcon}
                                                alt="Edit"
                                              />
                                            </span>
                                          </div>
                                        )}
                                      </StyledTableCell>
                                    )}
                                  {item?.title === "DefaultTax" ? (
                                    <>
                                      {editTaxesObj && (
                                        <>
                                          <StyledTableCell
                                            align="right"
                                            className="categories_add_delete "
                                            sx={{ width: "100px" }}
                                          >
                                            <EditTaxesModal
                                              selectedTaxe={item}
                                              categoryOptions={categoryOptions}
                                              loadingCategories={
                                                loadingCategories
                                              }
                                            />
                                          </StyledTableCell>
                                          <StyledTableCell></StyledTableCell>
                                        </>
                                      )}
                                    </>
                                  ) : (
                                    <>
                                      {editTaxesObj && (
                                        <>
                                          <StyledTableCell
                                            align="right"
                                            sx={{ width: "100px" }}
                                          >
                                            <EditTaxesModal
                                              selectedTaxe={item}
                                              categoryOptions={categoryOptions}
                                              loadingCategories={
                                                loadingCategories
                                              }
                                            />
                                          </StyledTableCell>
                                        </>
                                      )}
                                      {deleteTaxButton && (
                                        <StyledTableCell>
                                          <span
                                            className="qv-tax-trigger qv-tax-trigger--delete cursor-pointer"
                                            onClick={() =>
                                              deletetaxButtonFun(item?.id)
                                            }
                                            role="button"
                                            tabIndex={0}
                                            onKeyDown={(e) => {
                                              if (
                                                e.key === "Enter" ||
                                                e.key === " "
                                              ) {
                                                e.preventDefault();
                                                deletetaxButtonFun(item?.id);
                                              }
                                            }}
                                          >
                                            <img
                                              src={DeleteIcon}
                                              alt="delete-icon"
                                            />
                                          </span>
                                        </StyledTableCell>
                                      )}
                                    </>
                                  )}

                                  {editButtonEnableEmployee && (
                                    <>
                                      <StyledTableCell sx={{ width: "50px" }}>
                                        {!permissions?.length ||
                                          permissions?.includes(
                                            PERMISSIONS?.MENU_MANAGE_STORE_ACCESS_PERMISSION
                                          ) ? (
                                          <span
                                            onClick={() => {
                                              handleEditEmployeePermission(
                                                item?.id
                                              );
                                            }}
                                            className="cursor-pointer"
                                          >
                                            <img
                                              // className="edit_center w-8 h-8"
                                              src={Permission}
                                              alt="Permission-icon"
                                            />
                                          </span>
                                        ) : null}
                                      </StyledTableCell>
                                    </>
                                  )}
                                  {employeeTable && (
                                    <>
                                      <StyledTableCell
                                        align="right"
                                        sx={{ width: "50px" }}
                                      >
                                        {!permissions?.length ||
                                          (permissions?.includes(
                                            PERMISSIONS?.MENU_MANAGE_STORE_ADD_OR_EDIT
                                          ) &&
                                            employeeTable) ? (
                                          <EditEmployeeModal
                                            selectedTaxe={item}
                                            employee={item}
                                            states={states}
                                          />
                                        ) : null}
                                      </StyledTableCell>
                                    </>
                                  )}

                                  <StyledTableCell sx={{ width: "50px" }}>
                                    {deleteButtonEnable ? (
                                      employeeTable &&
                                        +item?.is_admin ===
                                        1 ? null : item?.title?.toLowerCase() !==
                                          "quickadd" &&
                                          (showDeleteWhenNoPermission ||
                                            hasDeletePermission) ? (
                                        showDeleteWhenNoPermission ? (
                                          <AccessDeniedTooltip
                                            hasPermission={hasDeletePermission}
                                          >
                                            <img
                                              className="cursor-pointer"
                                              src={DeleteIcon}
                                              alt="delete-icon"
                                              onClick={() => {
                                                if (!hasDeletePermission) return;
                                                deleteButtonFun(
                                                  item?.id,
                                                  item?.title
                                                );
                                              }}
                                            />
                                          </AccessDeniedTooltip>
                                        ) : (
                                          <img
                                            className="cursor-pointer"
                                            src={DeleteIcon}
                                            alt="delete-icon"
                                            onClick={() =>
                                              deleteButtonFun(
                                                item?.id,
                                                item?.title
                                              )
                                            }
                                          />
                                        )
                                      ) : null
                                    ) : null}
                                  </StyledTableCell>

                                  {editAttributeObj && (
                                    <StyledTableCell
                                      sx={{ width: "1150px" }}
                                      align="right"
                                    >
                                      <EditDeliveryAddress
                                        attribute={item}
                                        allattributes={tableRow}
                                      />
                                    </StyledTableCell>
                                  )}
                                </StyledTableRow>
                              )}
                            </Draggable>
                          );
                        })}
                      {provided?.placeholder}
                    </TableBody>
                  )}
                </Droppable>
              </DragDropContext>
            </Table>
            {!tableRow?.length && !loading && <NoDataFound />}
          </TableContainer>
        </>
      )}

      <AlertModal
        modalClassName={feedbackModalClassName}
        headerText={alertModalHeaderText}
        open={alertModalOpen}
        onClose={() => {
          setAlertModalOpen(false);
        }}
      />
      <SortModal
        modalClassName={feedbackModalClassName}
        headerText="sort items"
        open={deleteModalOpen}
        onClose={() => {
          setDeleteModalOpen(false);
          setFunction(backupedCategoryList);
        }}
        onConfirm={confirmDeleteCategory}
        sortModeConfirmedLoading={sortModeConfirmedLoading}
      />
    </>
  );
};

export default DraggableTable;
